var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 252.073,
    height: 213.485,
    viewBox: "0 0 252.073 213.485",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cart",
    transform: "translate(126.036 106.744)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-126.036 -126.036)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M208.368,187.458H76.395a15.977,15.977,0,0,1-16.18-14.841,16.164,16.164,0,0,1,7.82-15.421L46.9,62.57a5.607,5.607,0,0,1,5.47-6.826h194.1a5.6,5.6,0,0,1,5.291,7.447L229.4,127.263a23.256,23.256,0,0,1-17.942,15.231L75.56,166.244l-.053.008a5.039,5.039,0,0,0,.893,10H208.374a5.6,5.6,0,1,1-.006,11.206ZM59.357,66.95,78.868,154.3l130.663-22.832a12.047,12.047,0,0,0,9.293-7.89l19.76-56.621H59.357Z",
    fill: "#425175"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M77.991,232.777a18.361,18.361,0,1,1,18.362-18.359A18.378,18.378,0,0,1,77.991,232.777Zm0-25.515a7.157,7.157,0,1,0,7.159,7.159A7.164,7.164,0,0,0,77.991,207.262Z",
    fill: "#425175"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M192.821,232.777a18.361,18.361,0,1,1,18.362-18.359A18.38,18.38,0,0,1,192.821,232.777Zm0-25.515a7.157,7.157,0,1,0,7.159,7.159A7.167,7.167,0,0,0,192.821,207.262Z",
    fill: "#425175"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M52.361,66.95A5.6,5.6,0,0,1,46.9,62.57L42.959,44.922a18.341,18.341,0,0,0-18-14.427H5.6a5.6,5.6,0,0,1,0-11.2H24.952A29.481,29.481,0,0,1,53.893,42.48l3.941,17.648a5.6,5.6,0,0,1-5.473,6.823Z",
    fill: "#425175"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.35719c8fa5426e381ca527626ee7e8e4.svg";
export { ForwardRef as ReactComponent };